import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { format } from "date-fns";
import moment from "moment";
import SelectDropdown from "../../components-react/SelectDropdown";
import {
  biomaxAppRegisterStatus,
  biomaxStatus,
  daysAgo,
  fitnessProfileStatus,
  handoverStatuses,
  isPTProspectStatus,
  payment_location,
  pendingCompletedStatus,
  pt_trial_status,
  ptTrials,
  ptTrialStatuses,
  ratingStatus,
  three_day_pt_trial_session_status,
  timeSlots,
  trial_added_from,
} from "../../common-data/DropdowData";
import { fetchGymData, fetchTrainersData } from "../../../data/APIs";
import { fetchInHouseUsersData } from "../../../redux/reducers/dropdownApiSlice";
import SelectDropdownLabel from "../../components-react/SelectDropdownLabel";
import RedButton from "../../common-components/RedButton";
import DateRanger from "../../components-react/DateRanger";
import { selectGymData } from "../../../redux/reducers/gymDataSlice";
import MultiSelect from "../../components-react/MultiSelect";
import {
  CrossIcon,
  DateRangerIcon,
  ReloadIcon,
  SearchIcon,
  UpIcon,
  DownIcon,
} from "../../../images/icons/icons";

const PTTableFilters = ({
  filters,
  setFilters,
  setSendableStatsFilters,
  searchFilterApplied,
  onClickSearch,
  handleKeyPress,
  onClickReset,
  decryptedText,
  isPTReports,
  onClickExportBtn,
  isPTOpen,
  trainerReceptionistInfo,
  isExport,
  isLoading,
  handleToggle,
  toggle,
  isReload,
}) => {
  const dispatch = useDispatch();
  const gymData = useSelector(selectGymData);
  const { inhouseUsers } = useSelector((state) => state.dropdown);

  const isAdmin = decryptedText?.account_type === "admin";
  const isTrainer = decryptedText?.account_type === "trainer";
  const isReceptionist = decryptedText?.account_type === "receptionist";
  const isFitnessManager = decryptedText?.account_type === "fitness_manager";

  const isTrialFiltersShow =
    isPTReports ||
    filters?.selectedCard === "total_completed" ||
    filters?.selectedCard === "total_converted" ||
    filters?.selectedCard === "trial_done_cnvrtd" ||
    filters?.selectedCard === "trial_notdone_cnvrtd" ||
    filters?.selectedCard === "total" ||
    filters?.selectedCard?.includes("_prspct") ||
    filters?.selectedCard === "added_from_engagement" ||
    filters?.selectedCard === "allSubsCount" ||
    filters?.selectedCard === "threeday_converted_amount";

  const [allReceptionists, setAllReceptionists] = useState([]);
  const [activeDateRanges, setActiveDateRanges] = useState({
    selPtScheduleDate: false,
    selExpCloserDate: false,
    selPtTrialAssignedDate: false,
    selPtInitiatedDate: false,
    selThreeDayDoneDate: false,
    selSubscriptionAddDate: false,
  });
  const getInitialRangeStates = (isTrialFiltersShow) => {
    const rangeStates = {
      selSubscriptionAddDate: [
        {
          startDate: null,
          endDate: null,
          key: "selSubscriptionAddDate",
        },
      ],
      selPtScheduleDate: [
        {
          startDate: null,
          endDate: null,
          key: "selPtScheduleDate",
        },
      ],
      selThreeDayDoneDate: [
        {
          startDate: null,
          endDate: null,
          key: "selThreeDayDoneDate",
        },
      ],
    };
    if (
      isTrialFiltersShow ||
      filters?.selectedCard === "threeday_converted_amount"
    ) {
      rangeStates.selPtTrialAssignedDate = [
        {
          startDate: null,
          endDate: null,
          key: "selPtTrialAssignedDate",
        },
      ];

      rangeStates.selPtInitiatedDate = [
        {
          startDate: null,
          endDate: null,
          key: "selPtInitiatedDate",
        },
      ];
    }

    return rangeStates;
  };
  const [rangeStates, setRangeStates] = useState(() =>
    getInitialRangeStates(isTrialFiltersShow)
  );
  const [showFiltersDropdown, setShowFiltersDropdown] = useState(false);

  const hasActiveFilters = () => {
    return Object.keys(filters).some((key) => {
      const value = filters[key];

      if (value === null || value === undefined || value === "") return false;

      if (typeof value === "object" && value !== null) {
        return (
          value.value !== null &&
          value.value !== undefined &&
          value.value !== ""
        );
      }

      if (Array.isArray(value)) {
        return value.length > 0;
      }

      if (typeof value === "boolean") {
        return value === true;
      }

      return true;
    });
  };

  const handleDateRangeChangeMulti = (item, rangeKey) => {
    const startDate = item[rangeKey].startDate;
    const endDate = item[rangeKey].endDate;

    if (startDate && endDate) {
      setRangeStates({
        ...rangeStates,
        [rangeKey]: [item[rangeKey]],
      });

      const formattedStartDate = format(startDate, "yyyy-MM-dd");
      const formattedEndDate = format(endDate, "yyyy-MM-dd");

      setFilters({
        ...filters,
        [`${rangeKey}From`]: formattedStartDate,
        [`${rangeKey}To`]: formattedEndDate,
      });
    }
  };

  const clearDateRangerMulti = (rangeKey) => {
    getInitialRangeStates(isTrialFiltersShow);

    setFilters({
      ...filters,
      [`${rangeKey}From`]: "",
      [`${rangeKey}To`]: "",
    });
  };

  useEffect(() => {
    setSendableStatsFilters &&
      setSendableStatsFilters((prevs) => ({
        ...prevs,
        gym_id:
          (isReceptionist || isTrainer) && trainerReceptionistInfo?.gym_id
            ? trainerReceptionistInfo.gym_id
            : filters.selectedGym?.value
            ? filters.selectedGym.value
            : "",
        assigned_to:
          isTrainer && trainerReceptionistInfo?.user_id
            ? trainerReceptionistInfo.user_id
            : filters.selectedTrainer?.value
            ? filters.selectedTrainer.value
            : "",
        handover_status: isTrainer
          ? "handover_completed"
          : filters.selectedHandoverStatus?.value
          ? filters.selectedHandoverStatus.value
          : "",
        start_date: filters.selectedStartDate ? filters.selectedStartDate : "",
        end_date: filters.selectedEndDate ? filters.selectedEndDate : "",
        three_day_done_from: filters.selThreeDayDoneDateFrom
          ? filters.selThreeDayDoneDateFrom
          : "",
        three_day_done_to: filters.selThreeDayDoneDateTo
          ? filters.selThreeDayDoneDateTo
          : "",
        three_day_done_count: filters.threeDayDoneCount
          ? filters.threeDayDoneCount?.value
          : "",
      }));
  }, [
    filters.selectedGym,
    filters.selectedTrainer,
    filters.selectedHandoverStatus,
    filters.selectedStartDate,
    filters.selectedEndDate,
    trainerReceptionistInfo,
    filters.selThreeDayDoneDateFrom,
    filters.selThreeDayDoneDateTo,
    filters.threeDayDoneCount,
  ]);

  useEffect(() => {
    if (!isTrainer) {
      dispatch(
        fetchInHouseUsersData({
          token: decryptedText?.token,
          qps:
            !isAdmin && decryptedText?.gym_id
              ? `gym_id=${decryptedText.gym_id}`
              : filters.selectedGym?.value
              ? `gym_id=${filters.selectedGym?.value}`
              : "",
          pageNo: 1,
          limit: 100,
        })
      );

      dispatch(
        fetchTrainersData(
          decryptedText?.token,
          !isAdmin && decryptedText?.gym_id
            ? decryptedText?.gym_id
            : filters.selectedGym?.value
            ? filters.selectedGym?.value
            : ""
        )
      );
    }
  }, [isAdmin, filters.selectedGym?.value]);

  useEffect(() => {
    if (inhouseUsers) {
      setAllReceptionists(inhouseUsers);
    } else {
      setAllReceptionists([]);
    }
  }, [inhouseUsers]);

  useEffect(() => {
    if (isAdmin || isFitnessManager) {
      dispatch(fetchGymData(decryptedText?.token));
    }
  }, []);

  return (
    <div
      className={`cmnFilterStructureContainer ptTrackContainer ${
        isPTOpen ? "isPTOpen" : ""
      }`}
      style={{ marginTop: "1rem" }}
    >
      <div className="filterblock gridSpanTwo">
        <div className="filterHeadingNBtn">
          <div className="filterHeadingBtnBlock firstOne">
            <button
              type="button"
              className="pt-track-dropdown-toggle"
              onClick={() => setShowFiltersDropdown(!showFiltersDropdown)}
            >
              {showFiltersDropdown ? (
                <UpIcon />
              ) : (
                <DownIcon color={hasActiveFilters() ? "red" : ""} />
              )}
            </button>

            <h5 className="filterHeading">
              All Filters{" "}
              {isReload ? (
                <button
                  variant="dark"
                  type="button"
                  onClick={isReload}
                  style={{
                    width: "24px",
                    height: "24px",
                    borderRadius: "50%",
                    border: "none",
                    backgroundColor: "#000",
                    cursor: "pointer",
                    color: "#fff",
                    marginLeft: "10px",
                  }}
                >
                  <ReloadIcon />
                </button>
              ) : null}
            </h5>
          </div>

          {!isLoading && (
            <div className="filterHeadingBtnBlock lastOne">
              <label className="docs-toggle-switch">
                <input
                  type="checkbox"
                  className="docs-toggle-switch__input"
                  checked={toggle}
                  onChange={handleToggle}
                />
                Show Future Trial
                <span className="docs-toggle-switch__slider" />
              </label>
              {isPTReports || isExport ? (
                <RedButton
                  btnName={"Export Data"}
                  onClickBtn={onClickExportBtn}
                />
              ) : null}
              <Button variant="outline-danger" onClick={onClickReset}>
                Reset Filter
              </Button>
            </div>
          )}
        </div>

        {showFiltersDropdown ? (
          <div className="filtersDropdown grid-4">
            <>
              {Object.keys(rangeStates).map((rangeKey, index) => (
                <React.Fragment key={rangeKey}>
                  {activeDateRanges[rangeKey] && (
                    <DateRanger
                      handleDateRangeChange={(item) =>
                        handleDateRangeChangeMulti(item, rangeKey)
                      }
                      rangeState={rangeStates[rangeKey]}
                      onClose={() =>
                        setActiveDateRanges((prevActiveDateRanges) => ({
                          ...prevActiveDateRanges,
                          [rangeKey]: false,
                        }))
                      }
                      onClear={() => clearDateRangerMulti(rangeKey)}
                    />
                  )}

                  <div
                    className={`commonWrapper dropdownCommonWrapper darerangerCommonWrapper 
                      ${
                        filters[`${rangeKey}From`] || filters[`${rangeKey}To`]
                          ? "redBorderRedText"
                          : ""
                      }`}
                  >
                    {activeDateRanges[rangeKey] ? (
                      <div className="closeAndClearDateRangerButtons">
                        <button
                          className="closeClearBtn notmalButtonStyles noStyle closeRangerBtn"
                          onClick={() =>
                            setActiveDateRanges((prevActiveDateRanges) => ({
                              ...prevActiveDateRanges,
                              [rangeKey]: false,
                            }))
                          }
                        >
                          Close
                        </button>
                        <button
                          className="closeClearBtn notmalButtonStyles noStyle clearRangerBtn"
                          onClick={() => clearDateRangerMulti(rangeKey)}
                          disabled={isLoading}
                        >
                          Clear
                        </button>
                      </div>
                    ) : (
                      <div className="flex-between">
                        <button
                          type="button"
                          className="notmalButtonStyles noStyle long_one"
                          onClick={() => {
                            setActiveDateRanges((prevActiveDateRanges) => ({
                              ...Object.keys(prevActiveDateRanges).reduce(
                                (acc, key) => {
                                  acc[key] =
                                    key === rangeKey
                                      ? !prevActiveDateRanges[key]
                                      : false;
                                  return acc;
                                },
                                {}
                              ),
                            }));
                          }}
                          disabled={isLoading}
                        >
                          {filters[`${rangeKey}From`] ||
                          filters[`${rangeKey}To`]
                            ? `${moment(filters[`${rangeKey}From`])
                                .tz("Asia/Kolkata")
                                .format("DD-MM-YYYY")} TO ${moment(
                                filters[`${rangeKey}To`]
                              )
                                .tz("Asia/Kolkata")
                                .format("DD-MM-YYYY")}`
                            : rangeKey === "selPtScheduleDate"
                            ? "Select PT Schedule Date"
                            : rangeKey === "selExpCloserDate"
                            ? "Select Closure Date"
                            : rangeKey === "selPtTrialAssignedDate"
                            ? "3 Day PT Trial"
                            : rangeKey === "selPtInitiatedDate"
                            ? "Select PT Initiated Date"
                            : rangeKey === "selThreeDayDoneDate"
                            ? "3 Day Session Date"
                            : rangeKey === "selSubscriptionAddDate"
                            ? "Subscription Add Date"
                            : "Select Date"}
                        </button>

                        <button
                          type="button"
                          className="notmalButtonStyles noStyle short_one"
                          onClick={() =>
                            !isLoading && clearDateRangerMulti(rangeKey)
                          }
                          disabled={isLoading}
                        >
                          <span className="icon calender">
                            {filters[`${rangeKey}From`] ||
                            filters[`${rangeKey}To`] ? (
                              <CrossIcon />
                            ) : (
                              <DateRangerIcon
                                color={
                                  filters[`${rangeKey}From`] ||
                                  filters[`${rangeKey}To`]
                                    ? "green"
                                    : "#898989"
                                }
                              />
                            )}
                          </span>
                        </button>
                      </div>
                    )}
                  </div>
                </React.Fragment>
              ))}

              {!isTrainer && (
                <>
                  {(isAdmin || isFitnessManager) && (
                    <div
                      className={`commonWrapper dropdownCommonWrapper ${
                        filters?.selectedGym?.value && "redBorderRedText"
                      }`}
                    >
                      <SelectDropdown
                        options={gymData}
                        selectedOption={filters?.selectedGym}
                        setSelectedOption={(selectedValue) =>
                          setFilters({
                            ...filters,
                            selectedGym: selectedValue,
                          })
                        }
                        name="Gym"
                        isDisable={isLoading}
                      />
                    </div>
                  )}

                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selectedSubsAddedBy?.value
                        ? "redBorderRedText"
                        : ""
                    }`}
                  >
                    <SelectDropdown
                      options={allReceptionists}
                      selectedOption={filters?.selectedSubsAddedBy}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selectedSubsAddedBy: selectedValue,
                        })
                      }
                      name="Subscription Added By"
                      isDisable={isLoading}
                    />
                  </div>

                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selectedReceptionist?.value
                        ? "redBorderRedText"
                        : ""
                    }`}
                  >
                    <SelectDropdown
                      options={allReceptionists?.filter(
                        (value) => !value?.label?.includes("trainer")
                      )}
                      selectedOption={filters?.selectedReceptionist}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selectedReceptionist: selectedValue,
                        })
                      }
                      name="Handover From"
                      isDisable={isLoading}
                    />
                  </div>

                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selectedTrainer?.value ? "redBorderRedText" : ""
                    }`}
                  >
                    <SelectDropdown
                      options={allReceptionists?.filter(
                        (value) =>
                          value?.label?.includes("trainer") ||
                          value?.label?.includes("fitness manager")
                      )}
                      selectedOption={filters?.selectedTrainer}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selectedTrainer: selectedValue,
                        })
                      }
                      name="Assigned To"
                      isDisable={isLoading}
                    />
                  </div>

                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selectedHandoverStatus?.value
                        ? "redBorderRedText"
                        : ""
                    }`}
                  >
                    <SelectDropdown
                      options={handoverStatuses}
                      selectedOption={filters?.selectedHandoverStatus}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selectedHandoverStatus: selectedValue,
                        })
                      }
                      name="Handover Status"
                      isDisable={isLoading}
                    />
                  </div>

                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selTrainerIntro?.value ? "redBorderRedText" : ""
                    }`}
                  >
                    <SelectDropdown
                      options={pendingCompletedStatus}
                      selectedOption={filters?.selTrainerIntro}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selTrainerIntro: selectedValue,
                        })
                      }
                      name="Trainer Intro Status"
                      isDisable={isLoading}
                    />
                  </div>
                </>
              )}

              <div
                className={`commonWrapper dropdownCommonWrapper ${
                  filters?.selectedPTTrialStatus?.value
                    ? "redBorderRedText"
                    : ""
                }`}
              >
                <SelectDropdown
                  options={ptTrialStatuses}
                  selectedOption={filters?.selectedPTTrialStatus}
                  setSelectedOption={(selectedValue) =>
                    setFilters({
                      ...filters,
                      selectedPTTrialStatus: selectedValue,
                    })
                  }
                  name="Trial Status"
                  isDisable={isLoading}
                />
              </div>

              <>
                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.handoverCompletedOn?.value
                      ? "redBorderRedText"
                      : ""
                  }`}
                >
                  <SelectDropdownLabel
                    options={daysAgo}
                    selectedOption={filters?.handoverCompletedOn}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        handoverCompletedOn: selectedValue,
                      })
                    }
                    name="Handover Completed On"
                    isDisable={isLoading}
                  />
                </div>

                {/* <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.trialCompletedOn?.value ? "redBorderRedText" : ""
                  }`}
                >
                  <SelectDropdownLabel
                    options={daysAgo}
                    selectedOption={filters?.trialCompletedOn}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        trialCompletedOn: selectedValue,
                      })
                    }
                    name="Trial Completed On"
                    isDisable={isLoading}
                  />
                </div> */}

                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.lastCheckedIn?.value ? "redBorderRedText" : ""
                  }`}
                >
                  <SelectDropdownLabel
                    options={daysAgo}
                    selectedOption={filters?.lastCheckedIn}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        lastCheckedIn: selectedValue,
                      })
                    }
                    name="Member Last Checkin"
                    isDisable={isLoading}
                  />
                </div>

                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selPTProspect?.value ? "redBorderRedText" : ""
                  }`}
                >
                  <SelectDropdownLabel
                    options={isPTProspectStatus}
                    selectedOption={filters?.selPTProspect}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selPTProspect: selectedValue,
                      })
                    }
                    name="PT Prospect"
                    isDisable={isLoading}
                  />
                </div>

                {/* <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selProspectStatus?.value ? "redBorderRedText" : ""
                  }`}
                >
                  <SelectDropdownLabel
                    options={prospectStatus}
                    selectedOption={filters?.selProspectStatus}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selProspectStatus: selectedValue,
                      })
                    }
                    name="Prospect Status"
                    isDisable={isLoading}
                  />
                </div> */}

                <div
                  className={`commonWrapper dropdownCommonWrapper multiselect-auto-scroll multiselect-filter ${
                    filters?.selLeastCheckinInBetween?.length > 0
                      ? "redBorderRedText"
                      : ""
                  }`}
                >
                  <MultiSelect
                    options={timeSlots}
                    state={filters?.selLeastCheckinInBetween}
                    setState={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selLeastCheckinInBetween: selectedValue,
                      })
                    }
                    name="Member Last Checkin"
                    preventKeyboardOpen={true}
                    isDisable={isLoading}
                  />
                </div>

                {isPTReports ? (
                  <>
                    <div
                      className={`commonWrapper dropdownCommonWrapper ${
                        filters?.lastWorkoutDaysAgo?.value
                          ? "redBorderRedText"
                          : ""
                      }`}
                    >
                      <SelectDropdownLabel
                        options={daysAgo}
                        selectedOption={filters?.lastWorkoutDaysAgo}
                        setSelectedOption={(selectedValue) =>
                          setFilters({
                            ...filters,
                            lastWorkoutDaysAgo: selectedValue,
                          })
                        }
                        name="Last Workout"
                        isDisable={isLoading}
                      />
                    </div>

                    <div
                      className={`commonWrapper dropdownCommonWrapper ${
                        filters?.isBiomaxRegister?.value
                          ? "redBorderRedText"
                          : ""
                      }`}
                    >
                      <SelectDropdownLabel
                        options={biomaxStatus}
                        selectedOption={filters?.isBiomaxRegister}
                        setSelectedOption={(selectedValue) =>
                          setFilters({
                            ...filters,
                            isBiomaxRegister: selectedValue,
                          })
                        }
                        name="Biomax Register Status"
                        isDisable={isLoading}
                      />
                    </div>

                    <div
                      className={`commonWrapper dropdownCommonWrapper ${
                        filters?.isFitnessProfile?.value
                          ? "redBorderRedText"
                          : ""
                      }`}
                    >
                      <SelectDropdownLabel
                        options={fitnessProfileStatus}
                        selectedOption={filters?.isFitnessProfile}
                        setSelectedOption={(selectedValue) =>
                          setFilters({
                            ...filters,
                            isFitnessProfile: selectedValue,
                          })
                        }
                        name="Fitness Profile Status"
                        isDisable={isLoading}
                      />
                    </div>

                    <div
                      className={`commonWrapper dropdownCommonWrapper ${
                        filters?.trainerRatingStatus?.value
                          ? "redBorderRedText"
                          : ""
                      }`}
                    >
                      <SelectDropdownLabel
                        options={ratingStatus}
                        selectedOption={filters?.trainerRatingStatus}
                        setSelectedOption={(selectedValue) =>
                          setFilters({
                            ...filters,
                            trainerRatingStatus: selectedValue,
                          })
                        }
                        name="Trainer Rating Status"
                        isDisable={isLoading}
                      />
                    </div>
                  </>
                ) : null}

                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selBiomaxAppRegister?.value
                      ? "redBorderRedText"
                      : ""
                  }`}
                >
                  <SelectDropdownLabel
                    options={biomaxAppRegisterStatus}
                    selectedOption={filters?.selBiomaxAppRegister}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selBiomaxAppRegister: selectedValue,
                      })
                    }
                    name="Biomax First Step (App Register)"
                    isDisable={isLoading}
                    preventKeyboardOpen={true}
                  />
                </div>

                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selTrialAddedFrom?.value ? "redBorderRedText" : ""
                  }`}
                >
                  <SelectDropdownLabel
                    options={trial_added_from}
                    selectedOption={filters?.selTrialAddedFrom}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selTrialAddedFrom: selectedValue,
                      })
                    }
                    name="Trial Added From"
                    isDisable={isLoading}
                    preventKeyboardOpen={true}
                  />
                </div>

                {isTrialFiltersShow && (
                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selectedPTTrial?.value ? "redBorderRedText" : ""
                    }`}
                  >
                    <SelectDropdownLabel
                      options={ptTrials}
                      selectedOption={filters?.selectedPTTrial}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selectedPTTrial: selectedValue,
                        })
                      }
                      name="3 Day Trial"
                      isDisable={isLoading}
                    />
                  </div>
                )}

                {isTrialFiltersShow && (
                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selectedPTTrialStartStatus?.value
                        ? "redBorderRedText"
                        : ""
                    }`}
                  >
                    <SelectDropdownLabel
                      options={pt_trial_status}
                      selectedOption={filters?.selectedPTTrialStartStatus}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selectedPTTrialStartStatus: selectedValue,
                        })
                      }
                      name="PT Trial Status"
                      isDisable={isLoading}
                    />
                  </div>
                )}

                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.selectedPaymentLocation?.value &&
                    "redBorderRedText"
                  }`}
                >
                  <SelectDropdown
                    options={payment_location}
                    selectedOption={filters?.selectedPaymentLocation}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        selectedPaymentLocation: selectedValue,
                      })
                    }
                    name="Payment Location"
                    isDisable={isLoading}
                  />
                </div>

                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.bcaReportStatus?.value ? "redBorderRedText" : ""
                  }`}
                >
                  <SelectDropdownLabel
                    options={[
                      {
                        value: "pending",
                        label: "Pending",
                      },
                      {
                        value: "completed",
                        label: "Completed",
                      },
                    ]}
                    selectedOption={filters?.bcaReportStatus}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        bcaReportStatus: selectedValue,
                      })
                    }
                    name="BCA Report Status"
                    isDisable={isLoading}
                  />
                </div>

                <div
                  className={`commonWrapper dropdownCommonWrapper ${
                    filters?.threeDayDoneCount?.value ? "redBorderRedText" : ""
                  }`}
                >
                  <SelectDropdownLabel
                    options={three_day_pt_trial_session_status}
                    selectedOption={filters?.threeDayDoneCount}
                    setSelectedOption={(selectedValue) =>
                      setFilters({
                        ...filters,
                        threeDayDoneCount: selectedValue,
                      })
                    }
                    name="3 Day Completed Session"
                    isDisable={isLoading}
                  />
                </div>

                {/* {isTrialFiltersShow && (
                  <div
                    className={`commonWrapper dropdownCommonWrapper ${
                      filters?.selectedConvertedStatus?.value
                        ? "redBorderRedText"
                        : ""
                    }`}
                  >
                    <SelectDropdownLabel
                      options={conversion_status_boolean}
                      selectedOption={filters?.selectedConvertedStatus}
                      setSelectedOption={(selectedValue) =>
                        setFilters({
                          ...filters,
                          selectedConvertedStatus: selectedValue,
                        })
                      }
                      name="3 Day Trial Status"
                      isDisable={isLoading}
                    />
                  </div>
                )} */}
              </>

              <div className="filter-searchbar-container span2">
                <div
                  className={`inputCommonWrapper flexSpacebetween searchBarContainer ${
                    searchFilterApplied ? "redBorderRedText" : ""
                  } ${isLoading ? "disabled" : ""}`}
                >
                  <input
                    type="search"
                    className="input"
                    placeholder="Search..."
                    value={filters?.searchString}
                    onChange={(e) =>
                      setFilters({
                        ...filters,
                        searchString: e.target.value,
                      })
                    }
                    onKeyDown={handleKeyPress}
                    disabled={isLoading}
                  />
                  {!isLoading && (
                    <button
                      type="button"
                      className="button"
                      onClick={onClickSearch}
                    >
                      search
                      <SearchIcon />
                    </button>
                  )}
                </div>
              </div>
            </>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default PTTableFilters;
